module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.value)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependantsValue),
      expression: "dependantsValue"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.dependantsValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.dependantsValue = $event.target.value
      }, _vm.updateTotals]
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.value - _vm.dependantsValue)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.value, _vm.dependantsValue)) + "%")])]), _vm._v(" "), (this.showInterest) ? _c('tr', [_c('td', [_vm._v(_vm._s(_vm.name) + " - Interest")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.interestAccrued)))]), _vm._v(" "), _c('td', [_c('div', {
    staticClass: "a-form-inputs"
  }, [_c('control', {
    attrs: {
      "before-after": "pound",
      "table-control": true
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dependantsInterestValue),
      expression: "dependantsInterestValue"
    }, {
      name: "field-control",
      rawName: "v-field-control"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "required": "",
      "type": "number"
    },
    domProps: {
      "value": (_vm.dependantsInterestValue)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.dependantsInterestValue = $event.target.value
      }, _vm.updateTotals]
    }
  })])], 1)]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.currencyFormat(_vm.interestAccrued - _vm.dependantsInterestValue)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.roundAndPercent(_vm.interestAccrued, _vm.dependantsInterestValue)) + "%")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e244bdb8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/documents/CustomHeadOfLoss.vue
// module id = 1822
// module chunks = 0